export default ({ className })=> {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="86"
      height="42"
      viewBox="0 0 86 42"
      className={className}
    >
      <path
        fill="#000F45"
        fill-rule="evenodd"
        d="M57,2 C57.03,2 57.052,2.014 57.082,2.016 L30.714,28.848 C30.334,29.234 29.666,29.234 29.286,28.848 L2.918,2.016 C2.948,2.014 2.97,2 3,2 L57,2 Z M21.064,24.266 C21.25,24.104 21.35,23.884 21.384,23.66 L27.86,30.25 C28.43,30.828 29.19,31.146 30,31.146 C30.81,31.146 31.57,30.828 32.14,30.25 L38.616,23.66 C38.65,23.884 38.75,24.104 38.936,24.266 L56.98,40 L3.02,40 L21.064,24.266 Z M2,3.936 L20.282,22.538 C20.092,22.562 19.904,22.624 19.75,22.758 L2,38.234 L2,3.936 Z M58,38.234 L40.25,22.758 C40.096,22.624 39.908,22.562 39.718,22.538 L58,3.936 L58,38.234 Z M57,0 C58.654,0 60,1.346 60,3 L60,39 C60,40.654 58.654,42 57,42 L3,42 C1.346,42 0,40.654 0,39 L0,3 C0,1.346 1.346,0 3,0 L57,0 Z M78.707,14.293 L85.415,21.001 L78.707,27.707 C78.511,27.903 78.255,28.001 77.999,28.001 C77.745,28.001 77.489,27.903 77.293,27.707 C76.903,27.317 76.903,26.683 77.293,26.293 L81.585,22.001 L65.999,22.001 C65.447,22.001 64.999,21.553 64.999,21.001 C64.999,20.447 65.447,20.001 65.999,20.001 L81.585,20.001 L77.293,15.707 C76.903,15.317 76.903,14.683 77.293,14.293 C77.683,13.903 78.317,13.903 78.707,14.293 Z"
      />
    </svg>
  )
}



// WEBPACK FOOTER //
// ./src/assets/images/email-sent-icon.js